export default __webpack_public_path__ + "imgs/toLove01.1cf78b1.jpeg";